import { EM } from "resource-planner-model";
import env from "../app/Environment";
import fetchService from "../utils/FetchService";
import {
  fetchAllList,
  fetchListPage,
  PaginatedListRequest,
  PaginatedListResponse
} from "../utils/PaginatedListService";
import { PersistEMResult } from "./EMsTypes";

export class EMService {
  constructor(private endpoint: string) {}

  async fetch(): Promise<EM[]> {
    return fetchAllList<EM>(`${this.endpoint}/ems`, (url) =>
      fetchService.fetch(url, {}).then((r) => r.json())
    ).catch((): any[] => []);
  }

  async fetchPage(
    request: PaginatedListRequest = {}
  ): Promise<PaginatedListResponse<EM>> {
    return fetchListPage<EM>(
      `${this.endpoint}/ems`,
      (url) => fetchService.fetch(url, {}).then((r) => r.json()),
      request
    ).catch(() => ({ items: [] as EM[] }));
  }

  async delete(id: string): Promise<void> {
    return fetchService
      .fetch(`${this.endpoint}/ems/${id}`, {
        method: "DELETE",
      })
      .then();
  }

  async persist(item: EM): Promise<PersistEMResult> {
    return fetchService
      .fetch(`${this.endpoint}/ems`, {
        method: "POST",
        body: JSON.stringify(item),
      })
      .then((r) => r.json());
  }

  async setJiraAccess(id: string): Promise<void> {
    return fetchService
      .fetch(`${this.endpoint}/ems/${id}/jira/access`, {
        method: "POST",
      })
      .then(async (response) => {
        if (response.status && response.status !== 200) {
          throw new Error(`failed to grant Jira access`);
        }
      });
  }

  async setConfluenceAccess(id: string): Promise<void> {
    return fetchService
      .fetch(`${this.endpoint}/ems/${id}/confluence/access`, {
        method: "POST",
      })
      .then(async (response) => {
        if (response.status && response.status !== 200) {
          throw new Error(`failed to grant Confluence access`);
        }
      });
  }
}

const service: EMService = new EMService(env.endpoint);

export default service;
